<template lang="html">
  <span>
    <span class="pb-2 has-text-weight-semibold is-size-6">Skills </span
    ><b-tooltip
      position="is-right"
      type="is-dark"
      multilined
      size="is-small"
      label="Skills learned through following the tutorial"
    >
      <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
    </b-tooltip>
    <div class="columns is-multiline">
      <div
        v-for="(value, key, index) in skillsByCategory"
        :key="index"
        class="column is-one-quarter"
      >
        <p class="is-size-7 has-text-weight-semibold">{{ key }}</p>
        <div v-for="skill in value" :key="skill.id">
          <b-tooltip
            type="is-light"
            size="is-small"
            position="is-top"
            multilined
            :label="skill.description"
          >
            <b-checkbox
              v-model="localSkill_ids"
              :native-value="skill.id"
              @input="updateSkills"
            >
              {{ skill.name }}
            </b-checkbox>
          </b-tooltip>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
// Components
import _ from 'lodash'
import { notificationMixin } from '@/mixins/notificationMixin'

export default {
  mixins: [notificationMixin],
  props: ['skill_ids'],
  data () {
    return {
      localSkill_ids: [],
      skills: [],
      skillsByCategory: []
    }
  },
  created () {
    this.localSkill_ids = this.skill_ids
    this.$store
      .dispatch('skills/index')
      .then((response) => {
        this.skills = response.data.data
        let skillsAttributes = this.skills.map((skill) => skill.attributes)
        this.skillsByCategory = _.groupBy(skillsAttributes, 'category')
      })
      .catch((error) => {
        console.log(error.response)
        this.alertError()
      })
  },
  methods: {
    updateSkills (value) {
      this.$emit('updateSkills', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
